import { motion } from "framer-motion";
import { FaArrowDown } from "react-icons/fa";

export default function TeamIntro() {
  return (
    <div
      style={{
        height: "100vh",
        background: "#000",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: "1.5rem",
      }}
    >
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ fontSize: "3rem", margin: 0 }}
      >
        Our Team
      </motion.h1>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <FaArrowDown size={32} />
        <p style={{ marginTop: "0.5rem", fontSize: "1.2rem" }}>Scroll down</p>
      </motion.div>
    </div>
  );
}
